import SiteKeyboardsContainer from 'components/SiteKeyboards/SiteKeyboardsContainer'
import SiteKeyboardsPresentation from 'components/SiteKeyboards/SiteKeyboardsPresentation'

export default {
  Container: SiteKeyboardsContainer,
  Presentation: SiteKeyboardsPresentation,
}
